import * as React from 'react'
import * as ReactModal from 'react-modal'

import CommentList, { CommentData } from './CommentList'

// XXX: hack, somehow react modal imported in storybook is exported as default
const ReactModalComponent = (ReactModal as any).default
  ? (ReactModal as any).default
  : ReactModal

export interface Props {
  id: string
  thumbnail?: string
  photo?: string
  author?: string
  note?: string
  loved?: boolean
  comments?: Array<CommentData>
  onClose?: () => void
  onLove?: () => void
  onComment?: (comment: string) => void
}

interface State {
  photoLoaded: boolean
  commentText: string
}

export default class PhotoModal extends React.Component<Props, State> {
  constructor (props: Props, context?: any) {
    super(props, context)
    this.state = {
      photoLoaded: false,
      commentText: ''
    }
  }

  render () {
    return (
      <ReactModalComponent
        isOpen
        contentLabel='Photo'
        onRequestClose={this.props.onClose}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          },
          content: {
            top: '60px',
            bottom: '60px',
            left: '50%',
            right: 'auto',
            transform: 'translateX(-50%)',
            padding: '0',
            minWidth: '70vw',
            backgroundColor: 'black',
            border: 'none'
          }
        }}>
        <div className='clearfix' style={{ height: '100%' }}>
          {this.props.loved !== undefined ? (
            <button
              className='btn absolute white'
              style={{ left: '12px', top: '12px', zIndex: 100 }}
              onClick={this.onLove}>
              {this.props.loved ? (
                <i className='fa fa-heart' />
              ) : (
                <i className='fa fa-heart-o' />
              )}
            </button>
          ) : null}
          <div className='md-col md-col-7 flex items-center justify-center relative height-70 md-full-height'>
            <div
              className='absolute white col col-7'
              style={{
                left: '12px',
                bottom: '12px',
                fontFamily: 'Roboto, sans-serif'
              }}>
              {this.props.note ? (
                <div className='mb1'>{this.props.note}</div>
              ) : null}
              {this.props.author ? <div>By {this.props.author}</div> : null}
            </div>
            {!this.state.photoLoaded ? (
              <img
                className='block'
                src={this.props.thumbnail}
                style={{ objectFit: 'contain', width: '100%', height: '100%' }}
              />
            ) : null}
            <img
              src={this.props.photo}
              style={{
                objectFit: 'contain',
                width: '100%',
                height: '100%',
                ...this.state.photoLoaded
                  ? { display: 'block' }
                  : { display: 'none' }
              }}
              onLoad={this.onLoad}
            />
          </div>
          <div className='md-col md-col-5 bg-white flex flex-column height-30 md-full-height'>
            <CommentList
              className='flex-auto'
              comments={this.props.comments || []}
            />
            <input
              value={this.state.commentText}
              className='border rounded bg-white p1 m1 border-box'
              style={{ fontSize: '16px' }}
              placeholder='Leave comment here'
              onChange={this.onCommentChange}
              onKeyUp={this.onCommentKeyup}
            />
          </div>
        </div>
      </ReactModalComponent>
    )
  }

  private onLoad = () => {
    this.setState({ photoLoaded: true })
  }

  private onLove = () => {
    if (this.props.onLove) {
      this.props.onLove()
    }
  }

  private onCommentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ commentText: event.target.value })
  }

  private onCommentKeyup = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      this.setState(state => {
        if (this.props.onComment) {
          this.props.onComment(state.commentText)
        }
        return { ...state, commentText: '' }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PhotoModal.tsx